



import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import AnagraficaDetail from '@/components/AnagraficaDetail.vue';
import { AnagraficaService } from '../../services/anagrafica.service';
import { Anagrafica } from '../../models/anagrafica.model';

@Component({
  components: {
    AnagraficaDetail
  }
})
export default class Iscritto extends Vue {

  @Inject('AnagraficaService')
  anagraficaService!: AnagraficaService;

  @Prop() id!: number;

  loading: boolean = false;
  anagrafica!: Anagrafica;

  constructor() {
    super();
  }

  beforeMount() {
    this.loading = true;
    const loadingCmp = this.$buefy.loading.open({});
    this.anagraficaService.getAnagrafica(this.id).then(result => {
      this.anagrafica = result;
    }).finally(() => {
      loadingCmp.close();
      this.loading = false;
    })
  }
}
